import styled from "styled-components";

export const PageRoot = styled.div`
  width: 100%;
  padding: 96px clamp(18px, 3vw, 40px) 72px;

  @media (max-width: 991px) {
    padding-top: 82px;
  }
`;

export const BackButton = styled.button.attrs({ type: "button" })`
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.palette.colors.muted};
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  margin-bottom: 18px;
`;

export const HeroShell = styled.section`
  position: relative;
  isolation: isolate;
  min-height: 392px;
  border-radius: 18px;
  overflow: hidden;
  padding: clamp(28px, 4vw, 52px);
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(220px, 320px);
  gap: 32px;
  align-items: end;
  background:
    linear-gradient(90deg, rgba(2, 6, 24, 0.94) 0%, rgba(2, 6, 24, 0.78) 42%, rgba(2, 6, 24, 0.26) 100%),
    linear-gradient(0deg, rgba(2, 6, 24, 0.62), rgba(2, 6, 24, 0.08)),
    ${({ image, theme }) => image ? `url(${image}) center / cover no-repeat` : theme.palette.colors.surfaceElevated};
  box-shadow: 0 28px 80px ${({ theme }) => theme.palette.colors.shadowStrong};
  margin-bottom: 8px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    min-height: 0;
    padding: 28px;
    background:
      linear-gradient(180deg, rgba(2, 6, 24, 0.9) 0%, rgba(2, 6, 24, 0.72) 100%),
      ${({ image, theme }) => image ? `url(${image}) center / cover no-repeat` : theme.palette.colors.surfaceElevated};
  }
`;

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  max-width: 760px;
  z-index: 1;
`;

export const HeroEyebrow = styled.div`
  width: fit-content;
  min-height: 26px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  padding: 5px 10px;
  background: rgba(2, 6, 24, 0.44);
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 13px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0;
  text-transform: uppercase;
`;

export const Title = styled.h1`
  margin: 0;
  max-width: 760px;
  font-size: clamp(36px, 5vw, 64px);
  line-height: 0.98;
  letter-spacing: 0;
  color: #FFFFFF;
`;

export const Subtitle = styled.p`
  margin: 0;
  max-width: 660px;
  font-size: 18px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.82);
`;

export const HeroActions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 22px;
  margin-top: 8px;

  @media (max-width: 700px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const ProgressStack = styled.div`
  width: min(520px, 100%);
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ProgressMeta = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 18px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 15px;
  font-weight: 700;
`;

export const ProgressBar = styled.div`
  width: 100%;
  max-width: ${({ compact }) => compact ? "180px" : "520px"};
  height: ${({ compact }) => compact ? "6px" : "8px"};
  border-radius: 999px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.22);
`;

export const ProgressFill = styled.div`
  height: 100%;
  border-radius: inherit;
  background: ${({ theme }) => theme.palette.blue.main};
`;

export const HeroStats = styled.div`
  position: relative;
  z-index: 1;
  align-self: end;
  display: grid;
  gap: 1px;
  border-radius: 14px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(18px);

  @media (max-width: 900px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const StatItem = styled.div`
  min-width: 0;
  min-height: 78px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  background: rgba(2, 6, 24, 0.58);
`;

export const StatValue = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: clamp(22px, 3vw, 34px);
  font-weight: 800;
  line-height: 1;
  color: #FFFFFF;
`;

export const StatLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 0;
  color: rgba(255, 255, 255, 0.62);
  text-transform: uppercase;
`;

export const EmptyState = styled.div`
  padding: 36px 0;
  font-size: 17px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.colors.muted};
`;
